import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import api from "../../api";

import Carousel from "../../components/posts/_carousel";
import APropos from "../../components/infos/aPropos";
import NewsletterForm from "../NewsLetter/NewsLetterForm";

const Accueil = () => {
  const [lastPosts, setLastPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const getImageUrl = (path) => {
    if (!path) return null;
    if (path.startsWith("http://") || path.startsWith("https://")) return path;

    return path.startsWith("/")
      ? `${process.env.REACT_APP_IMG_URL}${path}`
      : `${process.env.REACT_APP_IMG_URL}/${path}`;
  };

  const fetchLastPosts = async () => {
    try {
      setLoading(true);
      setError("");

      const response = await api.get("/posts/latest");

      setLastPosts(Array.isArray(response.data) ? response.data : []);
    } catch (err) {
      console.error(err);
      setError("Erreur lors du chargement des derniers articles.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLastPosts();
  }, []);

  const seoImage =
    lastPosts.length > 0
      ? getImageUrl(lastPosts[0]?.thumbnail || lastPosts[0]?.image)
      : null;

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-900">
        <div className="animate-pulse text-white text-xl">Chargement...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-900 px-4">
        <p className="mb-4 text-center text-white">{error}</p>

        <button
          onClick={fetchLastPosts}
          className="rounded bg-blue-600 px-4 py-2 text-white transition hover:bg-blue-700"
        >
          Réessayer
        </button>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <title>LMFP Photography - Photographe en Belgique dans la région de Liège</title>
        <meta name="description" content="Photographe spécialisé en portraits, mariages et événements en Belgique dans la région de Liège. Découvrez mes dernières réalisations et mon univers visuel." />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://www.lmfp-photography.com/" />

        <meta property="og:title" content="LMFP Photography - Photographe en Belgique" />
        <meta property="og:description" content="Portfolio photo : mariages, portraits et événements capturés avec émotion." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.lmfp-photography.com/" />
        <meta property="og:site_name" content="LMFP Photography" />
        <meta property="og:locale" content="fr_FR" />
        {seoImage && <meta property="og:image" content={seoImage} />}

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="LMFP Photography - Photographe en Belgique" />
        <meta name="twitter:description" content="Portfolio photo : mariages, portraits et événements capturés avec émotion." />
        {seoImage && <meta name="twitter:image" content={seoImage} />}
      </Helmet>

      <div className="min-h-screen bg-gray-900 text-white">
        <header className="border-b border-gray-700 p-4">
          <h1 className="text-center text-4xl font-bold">Accueil</h1>
        </header>

        <main className="container mx-auto">
          <section className="mb-8">
            <APropos />
          </section>

          <section className="mb-12">
            <h2 className="mb-4 text-center text-3xl font-bold">
              Derniers articles
            </h2>

            <Carousel featuredPost={lastPosts} />
          </section>

          <section className="mb-10 text-center">
            <div className="mx-auto max-w-2xl">
              <p className="mb-3 text-sm uppercase tracking-[0.3em] text-gray-500">
                Rester connecté
              </p>

              <h2 className="mb-4 text-2xl font-semibold text-gray-200 md:text-3xl">
                Ne manquez aucune nouvelle publication
              </h2>

              <p className="text-gray-400 leading-7">
                Recevez directement les prochains articles et projets photo dans
                votre boîte mail.
              </p>
            </div>
          </section>

          <section className="mb-12">
            <NewsletterForm />
          </section>
        </main>
      </div>
    </>
  );
};

export default Accueil;